<template>
    <transition name="slide">
        <div
            v-if="visible"
            class="fixed top-0 right-0 h-screen w-[380px] bg-white shadow-2xl border-l z-[9999]"
        >

            <!-- Header -->

            <div
                class="flex items-center justify-between p-4 border-b bg-orange-400"
            >

                <h2 class="font-bold">
                    Notifications
                </h2>

                <button @click="close">
                    <i class="fas fa-times"></i>
                </button>

            </div>

            <!-- Body -->

            <div
                class="overflow-y-auto h-[calc(100%-65px)]"
            >

                <div
                    v-if="notifications.length===0"
                    class="text-gray-500 p-6 text-center"
                >
                    No notifications
                </div>

                <div v-for="notification in notifications" :key="notification.notification_id" class="border-b p-2 hover:bg-gray-100 cursor-pointer":class="{'bg-blue-50 border-l-4 border-blue-500': notification.status==='Unread'}" >
                        <div class="flex justify-between text-sm" @click="markAsRead(notification)" @dblclick="openNotification(notification)">

                            <strong>
                            {{ notification.icon }} {{ notification.title }}
                            </strong>

                            <small>
                                {{ formatDate(notification.created_at) }}
                            </small>

                        </div>

                        <div class="mt-1 text-sm">
                            {{ notification.message }}
                        </div>
                </div>

            </div>

        </div>
    </transition>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import axios from "axios";

export default {

    props:{
        visible:Boolean
    },

    setup(){

        const store=useStore();

        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);

        const visible = computed(() => store.state.notifications.drawerOpen)

        const notifications=computed(()=>{
            return store.state.notifications.notifications;
        });


        const close = () => {
            store.commit("notifications/CLOSE_DRAWER")
        }

        const markAsRead = async(notification)=>{
            if(notification.status==="Unread"){
                let formData = {
                    notification: notification.notification_id,
                    user: userID.value,
                    company: companyID.value
                }
                await axios.post("api/v1/notifications/read/", formData)

                store.commit("notifications/MARK_AS_READ", notification.id)
            }

        }
        const openNotification = (notification) => {
            let modules_obj = {
                "HR": "Human Resource",
                "CRM": "CRM",
                "PMS": "Property Management",
                "HMS": "Hospital Management",
                "MMS": "Membership Management",
                "Accounts": "Financial Accounts",
                "Inventory": "Inventory Management",
                "PSS": "Property Sales",
                "VSS": "Vehicle Sales",
                "Settings": "Settings",
            }
            if(notification.action && notification.action_id){
                if (notification.action === "hr.leave.open") {
                    store.commit('modulesTab/ADD_TAB', modules_obj[notification.module]);
                    store.commit('pageTab/ADD_PAGE', {'HR':'Leave_Applications'});
                    store.state.pageTab.hrActiveTab = 'Leave_Applications'; 
                }
                if(notification.action === "crm.task.open"){
                    store.commit('modulesTab/ADD_TAB', modules_obj[notification.module]);
                    store.commit('pageTab/ADD_PAGE', {'CRM':'Lead_Tasks'});
                    store.state.pageTab.crmActiveTab = 'Lead_Tasks'; 
                }
                close();
            }
        }

        const formatDate=(date)=>{
            return new Date(date).toLocaleTimeString();
        }

        return{
            notifications,visible,
            formatDate,markAsRead,openNotification,close
        }

    }

}
</script>

<style scoped>

.slide-enter-active,
.slide-leave-active{
    transition:.25s;
}

.slide-enter-from,
.slide-leave-to{
    transform:translateX(100%);
}

</style>